import api from './api';

const clienteService = {
  // Obtener todos los clientes
  getClientes: async () => {
    try {
      const response = await api.get('/clientes');
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Obtener cliente por ID
  getClienteById: async (id) => {
    try {
      const response = await api.get(`/clientes/${id}`);
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Crear nuevo cliente
  createCliente: async (clienteData) => {
    try {
      const response = await api.post('/clientes', clienteData);
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Actualizar cliente
  updateCliente: async (id, clienteData) => {
    try {
      const response = await api.put(`/clientes/${id}`, clienteData);
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Eliminar cliente
  deleteCliente: async (id) => {
    try {
      const response = await api.delete(`/clientes/${id}`);
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Buscar clientes
  buscarClientes: async (busqueda) => {
    try {
      const response = await api.get(`/clientes/buscar?busqueda=${encodeURIComponent(busqueda)}`);
      return response;
    } catch (error) {
      throw error;
    }
  }
};

export default clienteService;